import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { terminalId: Number }
  static targets = ["indicator"]

  connect() {
    this.datetimeField = this.element.querySelector("[name='new_sale_date_time']")
    if (this.datetimeField) {
      this.datetimeField.addEventListener("change", this.onChange.bind(this))
      this.checkShift()
    }
  }

  disconnect() {
    if (this.datetimeField) {
      this.datetimeField.removeEventListener("change", this.onChange.bind(this))
    }
    if (this.timer) clearTimeout(this.timer)
  }

  onChange() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.checkShift(), 300)
  }

  async checkShift() {
    const dateTime = this.datetimeField && this.datetimeField.value
    if (!dateTime || !this.terminalIdValue) return

    this.indicatorTarget.innerHTML = `<span class="text-gray-400 text-sm">Vérification…</span>`

    try {
      const url = `/admin/cash_book/shift_for_date?terminal_id=${this.terminalIdValue}&date_time=${encodeURIComponent(dateTime)}`
      const res = await fetch(url, { headers: { "Accept": "application/json" } })
      const data = await res.json()

      if (data.found) {
        this.indicatorTarget.innerHTML = `
          <div class="bg-green-50 border border-green-200 rounded-lg p-3 text-sm">
            <div class="flex items-start gap-2">
              <svg class="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div>
                <p class="text-green-800 font-medium">Shift trouvé</p>
                <p class="text-green-700 text-xs mt-0.5">${data.user_name} — ${data.start_time}${data.end_time !== 'En cours' ? ' → ' + data.end_time : ''}</p>
              </div>
            </div>
          </div>
        `
      } else {
        const currentShift = this.element.dataset.currentShift
        this.indicatorTarget.innerHTML = `
          <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">
            <div class="flex items-start gap-2">
              <svg class="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
              </svg>
              <div>
                <p class="text-amber-800 font-medium">Aucun shift trouvé</p>
                <p class="text-amber-700 text-xs mt-0.5">Le ticket gardera son shift actuel${currentShift ? ` (${currentShift})` : ''}</p>
              </div>
            </div>
          </div>
        `
      }
    } catch (e) {
      this.indicatorTarget.innerHTML = ""
    }
  }
}
